module.exports = __webpack_public_path__ + "static/img/contract.a689cc35.png";